// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_fgu","image":"Header_image__2jUPV","name":"Header_name__12O78","info":"Header_info__2sR9i","infoRow":"Header_infoRow__1DXR4"};